import { useUserStore } from '@/stores/index';
import { useAnswerDateStore } from '@/stores/answer_date';

/**
 * セッション切れ時のリダイレクト先パスを返すユーティリティ関数。
 *
 * WebSurvey（署名付きURL経由）または回答リンク（AutoSignIn）経由のユーザーは
 * ID/パスワードを持たないため、ログイン画面ではなく専用の「セッション期限切れ」画面
 * （/session-expired）にリダイレクトする。通常のログインユーザーは従来通り /auth/login へ。
 *
 * 判定に使用するフラグ:
 * - userStore.is_websurvey: LoginWebSurvey（署名付きURL）経由でログインしたユーザー
 * - answerDateStore.is_auto_sign_in: AutoSignIn（回答リンク）経由でログインしたユーザー
 * ※ 両フラグはpersist:trueでLocalStorageに永続化される。通常ログイン時（Login.vue）で
 *   明示的にfalseにリセットし、ステート汚染を防止している。
 *
 * 注意: ストアの $reset() を呼ぶ前にこの関数を実行すること（リセット後はフラグが消失するため）。
 *
 * 利用箇所:
 * - router/index.ts: ルーターガード（api_token==null、フロントエンド期限切れ）
 * - QuestionItem.vue, QuestionConfirm.vue, AnswerEdit.vue: 回答送信時の401レスポンスハンドラ
 * - temporarySave.ts: 一時保存時の401レスポンスハンドラ
 *
 * 能動的ログアウト（ユーザーが自発的にログアウトボタンを押した場合）には使用しないこと。
 * 能動的ログアウトは常に /auth/login に遷移させる（TheContainer.vue, HomeContainer.vue）。
 *
 * 戻り値:
 * - WebSurvey/AutoSignInユーザー: { path: '/session-expired', query: { websurvey: '1' } }
 * - 通常ユーザー: '/auth/login'
 * ※ $reset()後もSessionExpired.vueでWebSurvey判定できるよう、queryパラメータで情報を渡す
 */
export function getSessionExpiredRedirectPath(): string | { path: string; query: Record<string, string> } {
  const userStore = useUserStore();
  const answerDateStore = useAnswerDateStore();
  const isWebSurvey = userStore.is_websurvey;
  const isAutoSignIn = answerDateStore.is_auto_sign_in;

  if (isWebSurvey || isAutoSignIn) {
    return { path: '/session-expired', query: { websurvey: '1' } };
  }
  return '/auth/login';
}
